// extracted by mini-css-extract-plugin
export var avatar = "_qr-3";
export var avatarContainer = "_qr-2";
export var avatarSpacer = "_qr-5";
export var avatarSpacerContainer = "_qr-4";
export var avatarStackContainer = "_qr-1";
export var bubble = "_qr-0";
export var remainderBubble = "_qr-6";